import { inject, Injectable, signal } from '@angular/core';
import { ROUTER_TOKENS } from '../app.routes';
// Footer
import { IFooter } from '@web-nx-ng-tsc/web-promo-shared-ui';
import { ApiService, IProductSearchOptions } from '@web-nx-ng-tsc/web-shared-data-access';
import { catchError, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

import { ILocalStorageModel, LS, StorageService } from '@web-nx-ng-tsc/data-access';
import {
  NG_APP_S3_PUB_BULB_URL,
  NG_APP_WEB_TOYO_URL,
  NG_APP_WEB_NANKANG_URL,
  NG_APP_WEB_NITTO_URL,
  NG_APP_WEB_WARRANTY_GRIP_URL,
  NG_APP_WEB_VERIFY_WARRANTY_URL,
  NG_APP_WEB_ADVANCE_URL,
} from '@web-nx-ng-tsc/shared-constant';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
export const VISIBILITY = environment.visibility;
export interface IMenuEntity {
  title: string;
  url: string;
  isRoute: boolean;
  isCategory?: boolean;
  submenu?: IMenuEntity[];
  parentTitleId?: string;
  parentBrand?: string;
}

export interface IMenuList extends IMenuEntity {
  submenu?: IMenuEntity[];
}
@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private readonly apiService = inject(ApiService);
  private readonly storageService = inject(StorageService);
  private readonly loggingService = inject(LoggingService);

  getMenu() {
    return this.apiService.getMenuProduct(VISIBILITY).pipe(
      tap((data: any) => {
        this.setStorage(LS.categoryList, data.rows);
      }),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getAllProductByCategory[ProductService] :', error);
        return throwError(() => error);
      })
    );
  }
  getSubMenuTireBrand() {
    return this.apiService.getSubMenuBrandTire(VISIBILITY).pipe(
      tap((data: any) => {
        console.log('getSubMenuTireBrand data:', data);

        this.setStorage(LS.categoryList, data.rows);
      }),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getSubMenuTire[ProductService] :', error);
        return throwError(() => error);
      })
    );
  }
  getSubMenuTire(brandId: string) {
    return this.apiService.getSubMenuTire(VISIBILITY, brandId).pipe(
      tap((data: any) => {
        console.log('CATCH ERROR | getSubMenuTire[ProductService] :', data);
        this.setStorage(LS.categoryList, data.rows);
      }),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getSubMenuTire[ProductService] :', error);
        return throwError(() => error);
      })
    );
  }
  getSubMenuModelTire(input: string, options: IProductSearchOptions) {
    // this.loggingService.log('CATCH ERROR | getSubMenuTire[ProductService] :', bandName);
    return this.apiService.getSubMenuModelTire(VISIBILITY, '1', input, options).pipe(
      tap((data: any) => {
        this.loggingService.log('CATCH ERROR | getSubMenuTire[ProductService] :', data);

        this.setStorage(LS.categoryList, data.rows);
      }),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getSubMenuTire[ProductService] :', error);
        return throwError(() => error);
      })
    );
  }
  getSubMenuIDTire(name: string, brand: string) {
    return this.apiService.getSubMenuIDTire(VISIBILITY, name, brand).pipe(
      tap((data: any) => {
        this.setStorage(LS.categoryList, data.rows);
      }),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getSubMenuTire[ProductService] :', error);
        return throwError(() => error);
      })
    );
  }
  private defaultMenuList = signal<IMenuList[]>([
    {
      title: 'สินค้า',
      url: '',
      isRoute: false,
      submenu: [
        {
          title: 'ยางรถยนต์',
          url: `${ROUTER_TOKENS.PRODUCTS}/${ROUTER_TOKENS.TIRE}/list`,
          isRoute: true,
          isCategory: true,
        },
        {
          title: 'น้ำมันเครื่อง',
          url: `${ROUTER_TOKENS.PRODUCTS}/${ROUTER_TOKENS.LUBRICANT}/list`,
          isRoute: true,
          isCategory: true,
        },
        {
          title: 'ผ้าเบรก',
          url: `${ROUTER_TOKENS.PRODUCTS}/${ROUTER_TOKENS.BREAK}/list`,
          isRoute: true,
          isCategory: true,
        },
      ],
    },

    {
      title: 'รุ่นยาง',
      url: '',
      isRoute: false,
      submenu: [
        {
          title: 'ยางรถยนต์',
          url: `${ROUTER_TOKENS.PRODUCTS}/${ROUTER_TOKENS.TIRE}/list`,
          isRoute: true,
          submenu: [
            {
              title: 'ยางรถยนต์',
              url: `${ROUTER_TOKENS.PRODUCTS}/${ROUTER_TOKENS.TIRE}/list`,
              isRoute: true,
              parentTitleId: '1',
            },
          ],
        },
      ],
    },
    {
      title: 'ยางรถ EV/OEM',
      url: '',
      isRoute: false,
      submenu: [
        {
          title: 'ยางรถ EV',
          url: `${NG_APP_S3_PUB_BULB_URL}/TOYO%2BEV_online_updated.pdf`,
          isRoute: false,
        },
        {
          title: 'ยางติดรถ OEM',
          url: `${NG_APP_S3_PUB_BULB_URL}/TOYO%2BOEM_online_updated.pdf`,
          isRoute: false,
        },
      ],
    },
    {
      title: 'โปรโมชั่น',
      url: `${ROUTER_TOKENS.PROMOTIONS}/list`,
      isRoute: true,
    },
    {
      title: 'แกลเลอรี่',
      url: `${ROUTER_TOKENS.GALLERY}/list`,
      isRoute: true,
    },
    {
      title: 'ข่าวสาร/ความรู้',
      url: '',
      isRoute: false,
      submenu: [
        {
          title: 'บทความ',
          url: `${ROUTER_TOKENS.ARTICLE}/list`,
          isRoute: true,
        },
        {
          title: 'วิดีโอความรู้',
          url: `${ROUTER_TOKENS.VIDEOS}/list`,
          isRoute: true,
        },
        {
          title: 'ข่าวสาร',
          url: `${ROUTER_TOKENS.NEWS}/list`,
          isRoute: true,
        },
      ],
    },
    // {
    //   title: 'ข่าวสาร',
    //   url: `${ROUTER_TOKENS.NEWS}/list`,
    //   isRoute: true,
    // },
    {
      title: 'ค้นหาสาขา',
      url: `${ROUTER_TOKENS.BRANCHES}/list`,
      isRoute: true,
    },
    // {
    //   title: 'เกี่ยวกับเรา',
    //   url: '',
    //   isRoute: false,
    //   submenu: [
    //     {
    //       title: 'รู้จัก GRIP',
    //       url: `${ROUTER_TOKENS.ABOUT_US}/detail`,
    //       isRoute: true,
    //     },
    //     {
    //       title: 'สนใจเป็นตัวแทนจำหน่าย',
    //       url: `${ROUTER_TOKENS.ABOUT_US}/${ROUTER_TOKENS.FRANCHISE}`,
    //       isRoute: true,
    //     },
    //     {
    //       title: 'บริการหลังการขาย',
    //       url: `${ROUTER_TOKENS.ABOUT_US}/${ROUTER_TOKENS.AFTER_SALE_SERVICE}`,
    //       isRoute: true,
    //     },
    //     {
    //       title: 'ลงทะเบียนรับประกันยาง',
    //       url: `${NG_APP_WEB_WARRANTY_GRIP_URL}`,
    //       isRoute: false,
    //     },
    //     {
    //       title: 'ตรวจสอบการรับประกัน',
    //       url: `${NG_APP_WEB_VERIFY_WARRANTY_URL}`,
    //       isRoute: false,
    //     },
    //     {
    //       title: 'นโยบายการรับประกัน',
    //       url: `${ROUTER_TOKENS.ABOUT_US}/${ROUTER_TOKENS.WARRANTY_POLICY}`,
    //       isRoute: true,
    //     },
    //     {
    //       title: 'ติดต่อเรา',
    //       url: `${ROUTER_TOKENS.ABOUT_US}/${ROUTER_TOKENS.CONTACT_US}`,
    //       isRoute: true,
    //     },
    //     {
    //       title: 'ลิงก์ไปยัง Toyo Website',
    //       url: `${NG_APP_WEB_TOYO_URL}`,
    //       isRoute: false,
    //     },
    //     {
    //       title: 'ลิงก์ไปยัง Nitto Website',
    //       url: `${NG_APP_WEB_NITTO_URL}`,
    //       isRoute: false,
    //     },
    //     {
    //       title: 'ลิงก์ไปยัง Nankang Website',
    //       url: `${NG_APP_WEB_NANKANG_URL}`,
    //       isRoute: false,
    //     },
    //   ],
    // },
  ]);

  // NOTE: Footer
  private defaultFooterList = signal<IFooter>({
    logo: '/assets/images/img-footer-logo.webp',
    name: 'GRIP TIRES',
    menu: [
      {
        item: 1,
        header: 'สินค้าและบริการ',
        menu: [
          // {
          //   label: 'ยางรถยนต์',
          //   url: `${ROUTER_TOKENS.PRODUCTS}/${ROUTER_TOKENS.TIRE}/list`,
          //   newTab: false,
          // },
          // {
          //   label: 'น้ำมันเครื่อง',
          //   url: `${ROUTER_TOKENS.PRODUCTS}/${ROUTER_TOKENS.LUBRICANT}/list`,
          //   newTab: false,
          // },
          // {
          //   label: 'ผ้านเบรค',
          //   url: `${ROUTER_TOKENS.PRODUCTS}/${ROUTER_TOKENS.BREAK}/list`,
          //   newTab: false,
          // },

          {
            label: 'ยางรถ EV',
            url: `${NG_APP_S3_PUB_BULB_URL}/TOYO%2BEV_online_updated.pdf`,
            newTab: true,
          },
          {
            label: 'บทความ',
            url: `${ROUTER_TOKENS.ARTICLE}/list`,
            newTab: false,
            isCategory: true,
          },
          {
            label: 'โปรโมชั่น',
            url: `${ROUTER_TOKENS.PROMOTIONS}/list`,
            newTab: false,
            isCategory: true,
          },
          {
            label: 'แกลเลอรี่',
            url: `${ROUTER_TOKENS.GALLERY}/list`,
            newTab: false,
            isCategory: true,
          },
          {
            label: 'วิดีโอความรู้',
            url: `${ROUTER_TOKENS.VIDEOS}/list`,
            newTab: false,
            isCategory: true,
          },
          {
            label: 'ข่าวสาร',
            url: `${ROUTER_TOKENS.NEWS}/list`,
            newTab: false,
            isCategory: true,
          },
          {
            label: 'ค้นหาสาขา',
            url: `${ROUTER_TOKENS.BRANCHES}/list`,
            newTab: false,
            isCategory: true,
          },
        ],
      },
      {
        item: 2,
        header: 'เกี่ยวกับเรา',
        menu: [
          {
            label: 'รู้จัก GRIP',
            url: `${ROUTER_TOKENS.ABOUT_US}/detail`,
            newTab: false,
          },
          {
            label: 'สนใจเปิดสาขา',
            url: `${ROUTER_TOKENS.ABOUT_US}/${ROUTER_TOKENS.FRANCHISE}`,
            newTab: false,
          },
          {
            label: 'บริการหลังการขาย',
            url: `${ROUTER_TOKENS.ABOUT_US}/${ROUTER_TOKENS.AFTER_SALE_SERVICE}`,
            newTab: false,
          },
          {
            label: 'ลงทะเบียนรับประกันยาง',
            url: `${NG_APP_WEB_WARRANTY_GRIP_URL}`,
            newTab: true,
          },
          {
            label: 'ตรวจสอบการรับประกัน',
            url: `${NG_APP_WEB_VERIFY_WARRANTY_URL}`,
            newTab: true,
          },
          {
            label: 'GRIP Learning Center',
            url: `https://grip.froggenius.com/login`,
            newTab: true,
          },
          {
            label: 'นโยบายการรับประกัน',
            url: `${ROUTER_TOKENS.ABOUT_US}/${ROUTER_TOKENS.WARRANTY_POLICY}`,
            newTab: false,
          },
          {
            label: 'ติดต่อเรา',
            url: `${ROUTER_TOKENS.ABOUT_US}/${ROUTER_TOKENS.CONTACT_US}`,
            newTab: false,
          },
          {
            label: 'ลิงก์ไปยัง Toyo Website',
            url: `${NG_APP_WEB_TOYO_URL}`,
            newTab: true,
          },
          {
            label: 'ลิงก์ไปยัง Nitto Website',
            url: `${NG_APP_WEB_NITTO_URL}`,
            newTab: true,
          },
          {
            label: 'ลิงก์ไปยัง Nankang Website',
            url: `${NG_APP_WEB_NANKANG_URL}`,
            newTab: true,
          },
          {
            label: 'ลิงก์ไปยัง Advance Website',
            url: `${NG_APP_WEB_ADVANCE_URL}`,
            newTab: true,
          },
        ],
      },
    ],
    copyRight: {
      menu: [
        {
          label: 'ข้อกำหนดและเงื่อนไข',
          url: `${ROUTER_TOKENS.TERM_AND_CONDITION}`,
          newTab: false,
        },
        {
          label: 'นโยบายความเป็นส่วนตัว',
          url: `${ROUTER_TOKENS.PRIVACY_POLICY}`,
          newTab: false,
        },
        {
          label: 'นโยบายการใช้คุกกี้',
          url: `${ROUTER_TOKENS.COOKIES_POLICY}`,
          newTab: false,
        },
      ],
      followUs: [
        {
          icon: '/assets/icons/icon-social-foot-fb.png',
          url: 'https://www.facebook.com/GripThailand/?locale=th_TH',
          newTab: false,
        },
        {
          icon: '/assets/icons/icon-social-foot-yt.png',
          url: 'https://www.youtube.com/channel/UC4mcQFb6ODFYcvon1UX1Jfw',
          newTab: false,
        },
        {
          icon: '/assets/icons/icon-social-foot-tt.png',
          url: 'https://www.tiktok.com/@gripthailand',
          newTab: false,
        },
        {
          icon: '/assets/icons/icon-social-foot-ig.png',
          url: 'https://www.instagram.com/gripthailand/?hl=en',
          newTab: false,
        },
      ],
    },
  });

  get menuList() {
    return this.defaultMenuList;
  }

  // Footer
  get footerList() {
    return this.defaultFooterList;
  }

  getStorage<K extends keyof ILocalStorageModel>(key: K): ILocalStorageModel[K] | null {
    return this.storageService.get(key);
  }
  setStorage<K extends keyof ILocalStorageModel>(key: K, value: ILocalStorageModel[K]): void {
    this.storageService.set(key, value);
  }
}
